export function chartOptions(financialDataRow) {
  return {
    responsive: true,
    maintainAspectRatio: false,
    indexAxis: 'y',
    layout: {
      padding: {
        right: 75,
      },
    },
    scales: {
      y1: {
        type: 'category',
        display: false,
        offset: true,
        grid: {
          drawOnChartArea: false,
        },
      },
      y2: {
        type: 'category',
        offset: true,
        grid: {
          drawOnChartArea: false,
        },
        ticks: {
          color: '#383838',
          font: {
            weight: 'bold',
            size: 17,
          },
        },
      },
      y3: {
        type: 'category',
        display: false,
        offset: true,
        grid: {
          drawOnChartArea: false,
        },
      },
      y4: {
        type: 'category',
        display: false,
        offset: true,
        grid: {
          drawOnChartArea: false,
        },
      },
      x: {
        type: 'logarithmic',
        beginAtZero: true,
        ticks: {
          callback: (value) => `${value.toFixed(0)} €`,
          font: {
            size: 14,
          },
        },
      },
    },
    plugins: {
      tooltip: {
        bodyFont: {
          size: 18,
        },
        filter: (context) => context.dataset.label !== 'Ratio',
        callbacks: {
          title: (tooltipItem) => {
            const index = tooltipItem[0].dataIndex
            return financialDataRow.name[index]
          },
          label: (context) => {
            let label = context.dataset.label || ''
            if (context.parsed.y !== null) {
              label +=
                ': ' +
                new Intl.NumberFormat('fr-FR', {
                  style: 'currency',
                  currency: 'EUR',
                  minimumFractionDigits: 0,
                }).format(context.parsed.x)
            }
            return label
          },
        },
      },
      datalabels: {
        font: {
          weight: 'bold',
          size: 16.5,
        },
        formatter: (value) => {
          // Hide value with 0€ in the Chart
          if (value === 0) {
            return null
          }
          return new Intl.NumberFormat('fr-FR', {
            style: 'currency',
            currency: 'EUR',
            minimumFractionDigits: 0,
          }).format(value)
        },
      },
      legend: {
        labels: {
          filter: (item) => item.text !== 'Ratio',
          font: {
            size: 16,
          },
        },
        position: 'bottom',
      },
      title: {
        display: false,
      },
    },
  }
}
